module.exports = __webpack_public_path__ + "static/media/esio.207252f9.jpg";